<template>
    <v-dialog v-model="show" max-width="480" persistent no-click-animation>
        <v-card rounded="lg" elevation="8">
            <div class="d-flex justify-center pt-6 pb-2">
                <v-avatar color="primary" size="64">
                    <v-icon size="36" color="white">mdi-rocket-launch</v-icon>
                </v-avatar>
            </div>

            <v-card-title class="text-center text-h5 font-weight-bold pb-1">
                New Version Available
            </v-card-title>

            <v-card-text class="text-center px-8 pb-2">
                <p class="text-body-1 text-medium-emphasis mb-4">
                    A new version of Built Simple has been deployed with the latest features and improvements.
                </p>
            </v-card-text>

            <v-card-actions class="justify-center pa-6 pt-4">
                <v-btn
                    color="primary"
                    variant="flat"
                    size="large"
                    block
                    :loading="refreshing"
                    @click="refresh"
                >
                    <v-icon start>mdi-refresh</v-icon>
                    {{ refreshing ? 'Saving & Refreshing...' : 'Refresh Now' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const show = ref(false);

function handleVersionUpdate() {
    show.value = true;
}

const refreshing = ref(false);

function refresh() {
    refreshing.value = true;
    // Give components a chance to auto-save before reload
    window.dispatchEvent(new CustomEvent('app-before-version-refresh'));
    // Wait 2 seconds for save operations to complete, then reload
    setTimeout(() => {
        sessionStorage.removeItem('chunk-reload-ts');
        window.location.reload();
    }, 2000);
}

onMounted(() => {
    window.addEventListener('app-version-updated', handleVersionUpdate);
});

onBeforeUnmount(() => {
    window.removeEventListener('app-version-updated', handleVersionUpdate);
});
</script>
